import { useState } from "react";

import { Accordion, AccordionProps } from "@mui/material";
import { AccordionKey, accordionStorage } from "@shared";

interface PersistentAccordionProps extends AccordionProps {
  storageKey: AccordionKey;
}

export function PersistentAccordion({
  storageKey,
  defaultExpanded = false,
  onChange,
  expanded,
  ...props
}: PersistentAccordionProps) {
  const [isExpanded, setIsExpanded] = useState<boolean>(() => accordionStorage.get(storageKey) ?? defaultExpanded);

  const handleChange: AccordionProps["onChange"] = (event, isExpanded) => {
    setIsExpanded(isExpanded);
    accordionStorage.set(storageKey, isExpanded);

    onChange?.(event, isExpanded);
  };

  return <Accordion {...props} expanded={expanded ?? isExpanded} onChange={handleChange} />;
}
